import React, {useEffect} from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const Buy = () => {
    useEffect(()=> {
        document.getElementById("osta").style.backgroundColor = "#FF8303"
    }, [])

    const HandleDecrese = () => {
        const count = document.getElementById("count")

        if (Number(count.innerHTML) !== 1) {
            count.innerHTML = Math.floor(Number(count.innerHTML) - 1)
        }
    }

    const HandleSubmit = () => {
        var e = document.getElementById("flavor");
        var text = e.options[e.selectedIndex].text;

        localStorage.setItem("purchase_order", JSON.stringify({
            "count": Number(document.getElementById("count").innerHTML),
            "flavor": text
        }))

        window.location.href = "#/buy/card"
    }
    return (
        <div>
            <section class="gradient-main h-screen relative flex items-center justify-center overflow-hidden">
                <div class="mb-24 mobile-fullscreen">
                    <h1 class="text-white font-title text-2xl padding-left-mobile">1. Sisesta kogus</h1>
                    <div class="bg-color-2 p-8 rounded-md">
                        <div class="bg-white rounded-md w-275 h-275">
                            <img class="" src={require("../../assets/can.png")} alt=""></img>
                        </div>
                        <h1 class="font-title primary text-2xl mt-4">Sunsett sipper</h1>
                        <div class="flex mt-2">
                            <h2 class="primary font-sec text-xl">Kogus</h2>
                            <div class="flex bg-white rounded-md pl-1 pr-1 ml-2">
                                <button class="w-6 text-center" onClick={() => HandleDecrese()}>-</button>
                                <h1 id="count" class="mt-0.5">1</h1>
                                <button class="w-6 text-center" onClick={() => document.getElementById("count").innerHTML = Math.floor(Number(document.getElementById("count").innerHTML) + 1)}>+</button>
                            </div>
                        </div>
                        <div class="mt-2 flex">
                            <h2 class="primary font-sec text-xl">Maitse:</h2>
                            <select name="flavor" class="rounded-md ml-2"  id="flavor">
                                <option value="apelsiin">Apelsiin</option>
                                <option value="oun">Õun</option>
                                <option value="arbuus">Arbuus</option>
                            </select>
                        </div>
                        <button onClick={() => HandleSubmit()} class="btn bg-color-0 rounded-full relative p-2 w-64 mt-4">
                            <img class="absolute left-3 top-1.5" src={require("../../assets/icons8-shopping-cart-96 2.png")} alt="" />
                            <h1 class="text-white font-title text-xl">Edasi</h1>
                        </button>
                    </div>
                </div>
            </section>

            <div class="absolute top-0 w-full">
              <Navbar></Navbar>
            </div>
            <div class="hide-on-mobile">
            <Footer isBottom={true}></Footer>
            </div>
        </div>
    )
}

export default Buy;